import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

function EditEndTimeDialog({ open, onClose, onSave, newEndTime, setNewEndTime }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Indtast Afgangstid</DialogTitle>
      <DialogContent>
        <TextField
          label="Afgangstid"
          type="time"
          value={newEndTime}
          onChange={(e) => setNewEndTime(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 300, // 5 minutter pr. trin
          }}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuller</Button>
        <Button onClick={onSave} variant="contained">
          Gem
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditEndTimeDialog;
